var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M10.51 19.85c0 .62-.53 1.14-1.18 1.14-.65 0-1.17-.52-1.17-1.14V12.8a1.18 1.18 0 0 1 2.35 0v7.04z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M2.33 4.68h23.34v15.47c0 2.18-.9 4.13-2.29 5.55a7.78 7.78 0 0 1-5.52 2.3h-7.72c-2.14 0-4.1-.87-5.52-2.3a7.93 7.93 0 0 1-2.3-5.55V4.68zm2.32 2.33v13.14c0 1.5.62 2.86 1.58 3.85 1 1 2.42 1.58 3.9 1.58h7.73a5.41 5.41 0 0 0 5.4-5.43V7.01H4.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M15.16 19.85c0 .62-.52 1.14-1.18 1.14-.65 0-1.17-.52-1.17-1.14V12.8c0-.62.52-1.15 1.17-1.15.66 0 1.18.53 1.18 1.15v7.04zm4.65 0a1.16 1.16 0 0 1-2.32 0V12.8a1.16 1.16 0 0 1 2.32 0v7.04z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M21 7V3.3c0-.25-.1-.5-.29-.69-.18-.15-.4-.27-.68-.27H7.97a.98.98 0 0 0-.68.27.96.96 0 0 0-.28.69V7H4.65V3.29c0-.9.37-1.74 1-2.33A3.18 3.18 0 0 1 7.96 0h12.06a3.3 3.3 0 0 1 3.29 3.29V7h-2.33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#727271",
    d: "M26.82 4.65c.65 0 1.15.53 1.15 1.18 0 .65-.5 1.18-1.15 1.18H1.15a1.18 1.18 0 0 1 0-2.36h25.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSelect);
export default __webpack_public_path__ + "static/media/trash-select.138dd0c9455fee393996f8bd284d17b3.svg";
export { ForwardRef as ReactComponent };